import React, { useEffect, useState } from 'react';
import {
  Box, Typography, Grid, Alert, Skeleton, Chip,
} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import { useNavigate } from 'react-router-dom';
import { dmsApi } from '../services/dmsApi';
import DocumentCard from '../components/DocumentCard';
import useDmsPalette from '../hooks/useDmsPalette';

export default function CustomerPortal() {
  const MP = useDmsPalette();
  const navigate = useNavigate();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await dmsApi.listCustomerDocuments({ limit: 50 });
        setDocuments(data.documents || []);
      } catch (err) {
        setError(err.error || 'Failed to load your documents');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
        <PeopleIcon sx={{ color: MP.blue, fontSize: 32 }} />
        <Box>
          <Typography variant="h5" fontWeight={700}>My Documents</Typography>
          <Typography variant="body2" color="text.secondary">
            Documents shared with you in the Customer vault
          </Typography>
        </Box>
        <Chip label="Customer Portal" size="small" sx={{ ml: 'auto', bgcolor: `${MP.blue}22`, color: MP.blue }} />
      </Box>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      {loading ? (
        <Grid container spacing={2}>
          {[1, 2, 3].map((n) => (
            <Grid item xs={12} sm={6} md={4} key={n}>
              <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 2 }} />
            </Grid>
          ))}
        </Grid>
      ) : documents.length === 0 ? (
        <Alert severity="info">No documents have been shared with you yet.</Alert>
      ) : (
        <Grid container spacing={2}>
          {documents.map((doc) => (
            <Grid item xs={12} sm={6} md={4} key={doc._id}>
              <DocumentCard
                doc={doc}
                onSelect={() => navigate(`/document/${doc._id}`)}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
}